import createRouter from "./createRouter";
import LayoutContainer from "@/views/Layout/LayoutContainer.vue";

export const routes = [
  {
    path: '/sms',
    component: LayoutContainer,
    redirect: '/sms/user-sms-history',
    children: [
      {
        path: 'user-sms-history',
        name: 'UserSMSHistory',
        component: () => import('@/views/SMS/UserSMSHistory.vue'),
        meta: {
          title: '用户历史短信列表'
        }
      },
    ]
  }
]

export default createRouter(routes);